import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from './validation-errors.component';
import { NgZorroAntdModule } from '../../modules/nz-zorro-antd.module';

@NgModule({
	declarations: [
		ValidationErrorsComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule
	],
	exports: [
		ValidationErrorsComponent
	]
})

export class ValidationErrorsModule { }
